"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
export default function OrganizingTeam() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const teamMembers = [{
    id: 1,
    name: "Jill Speece, PhD\n",
    role: "Conference Chair",
    bio: "Assistant Professor, Industrial and Manufacturing Engineering, Cal Poly, San Luis Obispo",
    image: "https://superb-silkworm.10web.cloud/wp-content/uploads/2026/01/IMG_9710.jpg?v=iw7qjr42fe"
  }, {
    id: 2,
    name: "Di Lacey, DHSc",
    role: "Technical Program Lead",
    bio: "Vice Provost, Strategy, Growth & Transformation, Western University of Health Sciences",
    image: "https://superb-silkworm.10web.cloud/wp-content/uploads/2026/01/1736900514791.jpeg?v=jn1ptwidcbk"
  }, {
    id: 3,
    name: "Jamie Fairclough, PhD",
    role: "Logistics Coordinator",
    bio: "Director and Faculty, Engineering & Medicine, Dartmouth College",
    image: "https://eilhconference.org/wp-content/uploads/2026/02/1760659577203.jpeg?v=fiphlozqdii"
  }];
  return <section id="organizing-team" ref={sectionRef} className="py-16 px-6 !text-[hsl(158,54%,18%)] !bg-[hsl(158,54%,18%)] md:py-24 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {teamMembers.map((member, i) => <div key={member.id} data-index={i} className={`group flex flex-col items-center text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 hover:shadow-medium ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
          animationDelay: isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <div className="relative mb-6 overflow-hidden rounded-full transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-103">
                <SafeHydrate><Avatar className="size-40">
                  <AvatarImage src={member.image} alt={member.name} />
                  <AvatarFallback className="bg-primary-dark text-foreground text-2xl font-semibold">
                    {member.name.split(" ").map(n => n[0]).join("")}
                  </AvatarFallback>
                </Avatar></SafeHydrate>
              </div>
              <h3 className="text-xl font-bold mb-2 relative group-hover:after:w-full !font-serif !text-[hsl(0,0%,100%)] md:text-2xl after:absolute after:bottom-0 after:left-0 after:h-0.5 after:bg-accent after:w-0 after:transition-all after:duration-200 after:ease-out">
                {member.name}
              </h3>
              
              <p className="text-sm leading-relaxed max-w-xs !font-serif !text-[hsl(0,0%,100%)] md:text-base">
                {member.bio}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}